var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2609 9.27729C15.8734 9.06426 16.5174 8.95607 17.1659 8.95729C17.8019 8.956 18.4338 9.06008 19.0359 9.26529C21.2719 10.0303 22.8799 12.1313 22.8799 14.6033C22.8799 17.7223 20.3219 20.2503 17.1659 20.2503H7.16588C4.79888 20.2503 2.87988 18.3543 2.87988 16.0153C2.87988 13.6753 4.79888 11.7803 7.16588 11.7803C8.01251 11.7779 8.84093 12.0259 9.54688 12.4933",
    stroke: "#1776EE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99585 11.8592C7.76096 11.2318 7.64105 10.5672 7.64185 9.89724C7.64185 6.77824 10.1998 4.25024 13.3558 4.25024C16.2958 4.25024 18.7168 6.44424 19.0358 9.26524",
    stroke: "#1776EE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureicon2);
export default __webpack_public_path__ + "static/media/featureicon_2.7bad57a50776fb63ad58f3e80c7ea87d.svg";
export { ForwardRef as ReactComponent };